import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Login from './Pages/Auth/Login'
import Employee from "./Pages/Employee/Employee";

import { Provider } from "react-redux";
import store from "./Store";
import Admindashboard from "./Pages/Admindashboard/Admindashboard";

function App() {
  
  const router=createBrowserRouter([
    {
      path:'/',
      element:<Login />
    },
    {
      path:'/employee/:id?',
      element:<Employee/>
    },
    {
      path:'/admin',
      element:<Admindashboard/>
    }

  ])
  return (
    <div className="app">
    <Provider store={store}>
      <RouterProvider router={router}/>
    </Provider>
    </div>
  );
}

export default App;
